<template lang="html">
  <div class="editInput">
    <div class="_input">
      <div class="default_title" :class="{'hidden': change}">{{defalutTitle}}</div>
      <input type="text" name="" value="" @blur="handler" v-model="title" :class="{'hidden': !change}" maxlength="60">
    </div>
    <div class="edit_btn"  @click="modify">
      <img src="../../assets/img/edit-icon.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: ["defalutTitle"],
  data() {
    return {
      title: "",
      change: false
    };
  },
  methods: {
    modify() {
      this.title = this.defalutTitle
      this.change = !this.change;
    },
    handler() {
      this.change = false;
      this.$emit("changeTitle", this.title);
    }
  }
};
</script>

<style lang="scss">
.editInput {
  height: 30px;
  line-height: 30px;
  ._input {
    display: inline-block;
    max-width: 90%;
    .default_title {
      font-size: 20px;
      position: relative;
      font-weight: normal;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    input {
      height: 30px;
      border: 1px solid #ccc;
      position: relative;
      top: -11px;
      text-indent: 10px;
      color: #666;
    }
    .hidden {
      display: none;
    }
  }
  .edit_btn {
    height: 100%;
    margin-left: 16px;
    display: inline-block;
    cursor: pointer;
    img {
      display: block;
      margin: 6px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// editInput.vue?616bf504